import React from 'react';
import { HiOutlineBriefcase, HiOutlineCurrencyRupee, HiOutlineLocationMarker } from 'react-icons/hi';
import { PositionChip } from 'src/components/placementDrives/shared';
import { WorkingMode } from 'types';

interface OpportunitiesCardDetailProps {
	workingMode: string;
	minSalary: string;
	maxSalary: string;
	internshipSalary?: { min: number; max: number };
	internshipDuration?: number;
	location: string;
	type: string;
}

const formatWorkingMode = (workingMode: string): string => {
	switch (workingMode) {
		case WorkingMode.FULL_TIME:
			return 'Full-Time';
		case WorkingMode.INTERNSHIP:
			return 'Internship';
		case WorkingMode.INTERNSHIP_TO_FULL_TIME:
			return 'Internship + Full-Time';
		default:
			return workingMode;
	}
};

const OpportunitiesCardDetail: React.FC<OpportunitiesCardDetailProps> = ({
	workingMode,
	minSalary,
	maxSalary,
	internshipSalary,
	internshipDuration,
	location,
	type,
}) => {
	const isInternship = workingMode === WorkingMode.INTERNSHIP || workingMode === WorkingMode.INTERNSHIP_TO_FULL_TIME;
	const showInternshipSalary = isInternship && internshipSalary && internshipSalary.min > 0;
	const showFullTimeSalary =
		(workingMode === WorkingMode.FULL_TIME || workingMode === WorkingMode.INTERNSHIP_TO_FULL_TIME) &&
		minSalary !== '0' && maxSalary !== '0' && minSalary !== '' && maxSalary !== '';

	const duration = internshipDuration && internshipDuration > 0 ? ` · ${internshipDuration} ${internshipDuration === 1 ? 'month' : 'months'}` : '';

	return (
		<div className="mt-4 flex flex-wrap gap-2">
			<PositionChip icon={HiOutlineBriefcase} text={`${formatWorkingMode(workingMode)}${duration}`} />
			{showInternshipSalary ? (
				<PositionChip icon={HiOutlineCurrencyRupee} text={`Internship: ${internshipSalary?.min}K - ${internshipSalary?.max}K/month`} />
			) : null}
			{showFullTimeSalary ? <PositionChip icon={HiOutlineCurrencyRupee} text={`${minSalary} - ${maxSalary} LPA`} /> : null}
			{location || type ? <PositionChip icon={HiOutlineLocationMarker} text={[location, type].filter(Boolean).join(' · ')} /> : null}
		</div>
	);
};

export default OpportunitiesCardDetail;
